import client from '/src/services/client.js';

export default {
    getRoles : (data) => client.get(`roles`,data),
    getPermissions : (id,data) => client.get(`role/${id}/permissions`, data),
    addRole : (data) => client.post(`role`, data),
    updateRole : (id, data) => client.put(`role/${id}`, data),
    deleteRole : (id) => client.delete(`role/${id}`),
    attachPermission : (id,data) => client.post(`roles/${id}/permissions/attach`,data),
    detachPermission : (id,data) => client.post(`roles/${id}/permissions/detach`,data),
    checkAvailability : (data) => client.get(`role/check-availability`, data),
    getRolesFilter: async (params = {}, data) => {
        const queryString = Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        return client.get(`roles?${queryString}`, data);
    },
}